import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICrisisModalParams } from '@modules/commitment-manager/modules/dashboard/crisis-modal/crisis-modal.model';
import { FeatureFlag } from '@app/infrastructure/feature-flag-manager/feature-flag-decorator';
import { FEATURE_FLAGS } from '@app/infrastructure/feature-flag-manager/feature-flag-list';
import { FeatureFlagManagerService } from '@app/infrastructure/feature-flag-manager/feature-flag-manager.service';

@Component({
	selector: 'app-crisis-modal',
	templateUrl: './crisis-modal.component.html',
	styleUrls: ['./crisis-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrisisModalComponent {
	@FeatureFlag(FEATURE_FLAGS.ENABLE_CRISIS_POPOVER) public enableCrisisPopover: ICrisisModalParams | null;

	constructor(
		public dialogRef: MatDialogRef<CrisisModalComponent>,
		public featureFlagManagerService: FeatureFlagManagerService,
		private sanitizer: DomSanitizer,
	) {}

	public get title(): string {
		return this.enableCrisisPopover?.title || 'Important data update';
	}

	public get message(): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(this.enableCrisisPopover?.message || '');
	}

	public ngOnInit(): void {}
}
